import React, { useCallback } from 'react';
import { Box, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TodoState, VovClient } from '../../../../ApiOld/ApiServerVov';
import { useNavigate, useParams } from "react-router-dom";
import { useMobileApi } from '../../../../Api/Mobile/useMobileApi';
import { useSnackbar } from 'notistack';
import { RequestResponseDTOState, RequestResponseWithBuildingDTO, SetRequestStateEmployeeMobileRequest } from '../../../../ApiOld/Api/ApiServerVov';
import delay from '../../../Shared/Functions/Delay';
import SwipeableBox from '../../../Shared/SwipeableBox';
import { Close, Delete, Done } from '@mui/icons-material';

interface MobileRequestItemProps {
    request: RequestResponseWithBuildingDTO;
    onRefresh: () => void;
}

const MobileRequestItem: React.FC<MobileRequestItemProps> = ({ request, onRefresh }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();

    const navigate = useNavigate();
    const { authorizedMobileEmployeeApi } = useMobileApi(VovClient);

    const [swiped, setSwiped] = React.useState<{ direction: boolean } | null>(null);
    const [swipedCurrentAction, setSwipedCurrentAction] = React.useState<{ direction: boolean } | null>(null);

    const swipedCallback = useCallback((direction: string) => {
        if (direction === 'right') {

            if (request.id) {
                authorizedMobileEmployeeApi.setRequestStateEmployeeMobile(new SetRequestStateEmployeeMobileRequest({ requestId: request.id, state: request.state == TodoState.NEW ? TodoState.ACTIVE : TodoState.RESOLVED })).then((response) => {

                    if (response.success) {
                        enqueueSnackbar(t('requestStateChangedSuccesfully'), { variant: 'success' });
                        onRefresh();
                    } else {
                        enqueueSnackbar(t('noPermissionOnAction'), { variant: 'error' });
                    }
                });
            }
        }
        else if (direction === 'left') {
            setSwiped(null);
            /* if (wish.id)
                authorizedApi.completeWish(wish.id).then(x => {
                    setWishes(wishes.map(x => x.id === wish.id ? new WishDTO({ ...x, completed: true }) : x));
                    setSwipedCurrentAction(null);
                }); */
        }
    }, [authorizedMobileEmployeeApi, request, onRefresh, t, enqueueSnackbar]);

    React.useEffect(() => {
        delay(2000).then(() => {
            if (swipedCurrentAction && !swipeCancelRef.current) {
                swipedCallback(swipedCurrentAction.direction ? 'left' : 'right');
                setSwiped(null);
            }
            swipeCancelRef.current = false

        });
    }, [swipedCurrentAction, swipedCallback]);
    const swipeCancelRef = React.useRef(false);

    const getNextState = (state: RequestResponseDTOState | undefined): TodoState | undefined => {
        if (state === RequestResponseDTOState._0) {
            return TodoState.ACTIVE;
        } else if (state === RequestResponseDTOState._1) {
            return TodoState.RESOLVED;
        } else if (state === RequestResponseDTOState._2) {
            return TodoState.RESOLVED;
        }
        else return TodoState.NEW;
    }

    return (
        <Box display={'flex'}>
            {swiped && swiped.direction === false &&
                <Box display='flex' justifyContent='center' alignItems='center' borderRadius={4} border={1} m={1} borderColor={swiped.direction ? theme.palette.error.main : theme.palette.primary.main} color='white' bgcolor={theme.palette.primary.main} zIndex={100} >
                    <Stack direction='row' spacing={2} minWidth={80} justifyContent={'center'} alignItems={'center'}>
                        <IconButton sx={{ width: '100%' }} onClick={() => {
                            setSwipedCurrentAction(swiped);
                        }}>
                            <Done color='success' />
                        </IconButton>
                        {/*  <IconButton onClick={() => setSwiped(null)}>
                            <Close />
                        </IconButton> */}
                    </Stack>
                </Box>
            }
            <SwipeableBox
                onSwipeEnded={(direction) => { setSwiped({ direction: direction === 'left' }) }}
                onClick={() => { if (request.id) navigate('/' + params['lang']! + '/' + params['domain']! + '/employee/request-detail', { state: { request: request } }); }}
                sx={{
                    //bgcolor: 'background.paper',
                    width: '100%'
                }}
                key={request.id}
            >
                <Box width={'100%'} padding={2} bgcolor={'white'} boxShadow={1} borderBottom={'1px solid lightgray'} margin={'8px'} justifyContent={'space-between'} paddingRight={'8px'} borderRadius={'5px'}
                    /* onClick={() => { navigate('/' + params['lang']! + '/' + params['domain']! + '/employee/request-detail', { state: { request: request } }); }} */>
                    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} paddingRight={'8px'}>

                        <Typography fontSize={'14px'} textAlign={'center'} fontWeight={'bold'}>{request.text}</Typography>
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-end" // Aligns children to the right
                            paddingRight="8px"

                        >
                            <Typography fontSize="10px">{request.datetimeTo?.toLocaleDateString(i18n.language)}</Typography>
                            {request.unreadMessages !== undefined && request.unreadMessages > 0 && <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                width="18px"
                                height="18px"
                                borderRadius="50%"
                                sx={{ backgroundColor: '#404040', color: 'white', fontSize: '10px', fontWeight: 'bold' }}
                            >
                                {request.unreadMessages}
                            </Box>}
                        </Box>

                    </Box>
                    <Typography fontSize={'10px'} mr={'32px'}>{request.description && request.description.length > 100 ? request.description.substring(0, 100) : request.description}</Typography>
                </Box>
            </SwipeableBox>
        </Box>
    );
};

export default MobileRequestItem;